import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "956a8f82-f777-4914-ac1d-403c9d988ec8"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter956a8f82F7774914Ac1d403c9d988ec8(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter956a8f82F7774914Ac1d403c9d988ec8 footer`}>
      {props["links"] || <Navigation className="LinksC65489a982964034Ada0Fba82e0570a4" parentTag={buildClassName("LinksC65489a982964034Ada0Fba82e0570a4", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo763cdae32b5f446789180f7a441e91e5" parentTag={buildClassName("Logo763cdae32b5f446789180f7a441e91e5", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright5004598cCe9843bfB6f4590c7c69f79c" parentTag={buildClassName("Copyright5004598cCe9843bfB6f4590c7c69f79c", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow19e339cdAd64474a902dB8ab33a6a8db" parentTag={buildClassName("Groupflow19e339cdAd64474a902dB8ab33a6a8db", parentTag)} {...props} />}
    </footer>
  );
}

// id: "763cdae3-2b5f-4467-8918-0f7a441e91e5"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "956a8f82-f777-4914-ac1d-403c9d988ec8"
export function Logo763cdae32b5f446789180f7a441e91e5(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo763cdae32b5f446789180f7a441e91e5" parentTag={buildClassName("Logo763cdae32b5f446789180f7a441e91e5", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "5004598c-ce98-43bf-b6f4-590c7c69f79c"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "956a8f82-f777-4914-ac1d-403c9d988ec8"
export function Copyright5004598cCe9843bfB6f4590c7c69f79c(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright5004598cCe9843bfB6f4590c7c69f79c" parentTag={buildClassName("Copyright5004598cCe9843bfB6f4590c7c69f79c", parentTag)} {...props} />
  );
}

// id: "c65489a9-8296-4034-ada0-fba82e0570a4"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "956a8f82-f777-4914-ac1d-403c9d988ec8"
export function LinksC65489a982964034Ada0Fba82e0570a4(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksC65489a982964034Ada0Fba82e0570a4" parentTag={buildClassName("LinksC65489a982964034Ada0Fba82e0570a4", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "19e339cd-ad64-474a-902d-b8ab33a6a8db"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "956a8f82-f777-4914-ac1d-403c9d988ec8"
export function Groupflow19e339cdAd64474a902dB8ab33a6a8db(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow19e339cdAd64474a902dB8ab33a6a8db" parentTag={buildClassName("Groupflow19e339cdAd64474a902dB8ab33a6a8db", parentTag)} {...props} />
  );
}

// id: "a7505be2-5a62-4dd3-b174-cd9ab50c9421"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "763cdae3-2b5f-4467-8918-0f7a441e91e5"
export const LogoTypeA7505be25a624dd3B174Cd9ab50c9421 = "FOOTER";

// id: "a487afe9-f3ce-406d-8b44-fc2802c0b7bb"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "c65489a9-8296-4034-ada0-fba82e0570a4"
export const NavMenuSlugA487afe9F3ce406d8b44Fc2802c0b7bb = "footer-nav";

// id: "2b3c19dc-d9d7-4337-98e0-fb63c94176f5"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "763cdae3-2b5f-4467-8918-0f7a441e91e5"
export const ContentSlug2b3c19dcD9d7433798e0Fb63c94176f5 = "footer-logo";

const Components = {
  DefaultFooter956a8f82F7774914Ac1d403c9d988ec8,
  Logo763cdae32b5f446789180f7a441e91e5,
  Copyright5004598cCe9843bfB6f4590c7c69f79c,
  LinksC65489a982964034Ada0Fba82e0570a4,
  Groupflow19e339cdAd64474a902dB8ab33a6a8db,
  LogoTypeA7505be25a624dd3B174Cd9ab50c9421,
  NavMenuSlugA487afe9F3ce406d8b44Fc2802c0b7bb,
  ContentSlug2b3c19dcD9d7433798e0Fb63c94176f5
}

export default Components;